var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.update)?_c('social-feed-update',{attrs:{"update":_vm.update,"index":"0"}}):_vm._e(),(_vm.update)?_c('social-feed-comments',{attrs:{"update":_vm.update,"index":"0"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }